var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1400_18042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5435 4.73395C21.5538 4.9405 21.5581 5.14454 21.5581 5.35446C21.5581 11.6923 16.6054 19.0024 7.54805 19.0024C4.87153 19.0049 2.25098 18.2559 0 16.8453C0.390037 16.8887 0.782258 16.9109 1.17483 16.9116C3.39172 16.9154 5.54534 16.192 7.28861 14.8578C6.26173 14.8386 5.26666 14.5075 4.44238 13.9106C3.61811 13.3137 3.0058 12.4809 2.69099 11.5285C3.42827 11.6662 4.18812 11.6375 4.91223 11.4446C3.79885 11.2238 2.79788 10.6353 2.07857 9.77852C1.35925 8.92174 0.965721 7.84927 0.964517 6.74243V6.68365C1.64789 7.05421 2.41261 7.25953 3.19437 7.28234C2.15233 6.60352 1.41484 5.56352 1.13192 4.37387C0.848989 3.18421 1.04186 1.93425 1.67131 0.878192C2.90756 2.36007 4.44999 3.57204 6.1984 4.43537C7.94681 5.2987 9.8621 5.79408 11.8199 5.88933C11.574 4.86092 11.683 3.78222 12.1301 2.8203C12.5773 1.85838 13.3375 1.06691 14.2931 0.568469C15.2487 0.0700296 16.3463 -0.107567 17.416 0.0631845C18.4857 0.233936 19.4677 0.743508 20.21 1.51298C21.3131 1.30211 22.371 0.909082 23.338 0.35088C22.97 1.46157 22.201 2.40459 21.1737 3.00507C22.149 2.89099 23.1015 2.63631 24 2.24937C23.3396 3.21276 22.5076 4.05334 21.5435 4.73143",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1400_18042"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterLogo);
export default __webpack_public_path__ + "static/media/twitter-logo.08333da88947e5a7522e4b6da58cc1d5.svg";
export { ForwardRef as ReactComponent };